<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="intarnalRange"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on }">
      <DateRange
        :date-range="intarnalRange"
        :color="color"
      />
      <v-btn v-on="on" icon :color="color">
        <v-icon>mdi-calendar</v-icon>
      </v-btn>
    </template>
    <v-date-picker
      v-model="intarnalRange"
      locale="ja-jp"
      :day-format="nowdate => new Date(nowdate).getDate()"
      range
      no-title
      class="comparisons-range"
      :max="datepickerMax"
    >
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="menu = false"
      >
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="onClickOk"
        :disabled="disabledOk"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import DateRange from './DateRange'
import { format, parseISO, compareAsc, differenceInCalendarMonths, lastDayOfMonth } from 'date-fns'
import { ja as localeJa } from 'date-fns/locale'

export default {
  name: 'DatePickerRange',
  components: {
    DateRange
  },
  props: {
    // 親からもらうプロパティ
    /** 期間開始日 */
    from: {
      type: String,
    },
    /** 期間終了日 */
    to: {
      type: String,
    },
    color: {
      type: String,
      default: 'white'
    },
    /**
     * 暦月数制限
     * 選択日付範囲の歴月数の差が指定数を超えた場合、範囲指定不可（＝「OK」で確定させない）
     * ex.)12を指定した場合、指定日の前年同月/翌年同月の日付であれば指定可能（＝13カ月間）
     */
    limitCalendarMonthsCount: {
      type: Number,
      default: 0
    },
    /**
     * 未来月の日付を無効にする
     */
    disableDatesInFutureMonths: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      menu: false,
      intarnalRange: [],
      internalFrom: '',
      internalTo: '',
      disabledOk: false,
    }
  },
  watch: {
    /** 期間開始日 */
    from: function (value) {
      this.internalFrom = value
      this.intarnalRange = [this.internalFrom, this.internalTo]
    },
    /** 期間終了日 */
    to: function (value) {
      this.internalTo = value
      this.intarnalRange = [this.internalFrom, this.internalTo]
    },
    /** 選択期間 */
    intarnalRange: function (value) {
      if (Array.isArray(value) && value.length > 1) {
        // 選択期間が複数日の場合
        if (this.limitCalendarMonthsCount > 0) {
          // 選択可能な暦月数(カレンダー上の暦月数)が指定されていた場合
          let _from, _to
          let _sortedRange =
            this.intarnalRange.map((date) => {
              return parseISO(date)
            })
            .sort(compareAsc)
          _from = _sortedRange.slice(0 , 1).shift()
          _to = _sortedRange.slice(-1).shift()

          // 指定日付の暦月数を取得
          const _diffMonths = differenceInCalendarMonths(_from, _to)
          if (Math.abs(_diffMonths) > this.limitCalendarMonthsCount) {
            // 選択範囲日付の歴月数の差が、指定数を超えていた場合、OKボタンを非活性にする
            this.disabledOk = true
          } else {
            // 上記以外の場合、OKボタンを活性化
            this.disabledOk = false
          }
        } else {
          // 上記以外の場合、OKボタンを活性化
          this.disabledOk = false
        }
      } else {
        // 上記以外の場合、OKボタンを活性化
        this.disabledOk = false
      }
    }
  },
  computed: {
    /**
     * datepicker入力可能最大日
     */
    datepickerMax: function () {
      if (this.disableDatesInFutureMonths) {
        // 未来の月を入力不可とする場合
        // 当月末の日付を入力日付の最大値とする
        const _today = new Date()
        return format(lastDayOfMonth(_today), 'yyyy-MM-dd')
      } else {
        // 未来月が選択可能な場合、datepickerのmax(選択可能最大日)を設定しない(設定値は空)
        return undefined
      }
    },
  },
  methods: {
    /** OKボタンクリック時 */
    onClickOk() {
      if (!Array.isArray(this.intarnalRange)) return
      let _from, _to
      let sortedRange =
        this.intarnalRange.map((date) => {
          return parseISO(date)
        })
        .sort(compareAsc)
        .map((date) => {
          return format(date, 'yyyy-MM-dd', {'locale': localeJa})
        })
      _from = sortedRange.slice(0 , 1).shift()
      _to = sortedRange.slice(-1).shift()
      this.$refs.menu.save([_from, _to])
      // 親に通知(イベントデータは、from,toが格納されているオブジェクト)
      this.$emit('update', {'from': _from, 'to': _to});
    }
  },
}
</script>
